export default __webpack_public_path__ + "static/media/bugs.7feb0731.jpeg";